// CERSAI PAN WITH MOBILE-NO FLOW

import React, { useEffect, useState } from "react";
import Tab from "../../Components/kyc-components/Tab";
import BannerImage from "../../Components/login-components/banner-image/BannerImage";
import BottomCard from "../../Components/login-components/bottom-card/BottomCard";
import LogoContainer from "../../Components/login-components/logo-container/LogoContainer";
import PanCardFrame1 from "./Frames/PanCardFrame1";
import styles from "./KYCHomeScreen.module.css";
import { useSelector } from "react-redux";
import AadhaarCardFrame from "./Frames/AadhaarCardFrame/AadhaarCardFrame";
import OtherDocsFrame from "./Frames/OtherDocsFrame";
import MsHome from "../../Components/Maruti-Suzuki-components/MsHome";
import HiddenWrapper from "../../Components/global-components/hiddenWrapper/HiddenWrapper";
import InfoIcon from "@mui/icons-material/Info";
import { CommonTemplate } from "../../Components/global-components/CommonModal";
import Digitalformsixty from "./Frames/Digitalformsixty";
import { useNavigate } from "react-router-dom";

import Loader1 from "../../Components/loader-component/loader1"
import CommonButton from "../../Components/global-components/CommonButton/CommonButton";
import AnnouncementIcon from "../../Components/global-components/CommonIcons/AnnouncementIcon";
import { getAnnouncementMsg } from "../../services/announcement-msg";
import Marquee from "react-fast-marquee";
import NewCommonTemplate from "../../Components/global-components/NewCommon Modal";

// import { userLocation } from "../Redux/userData";

const KYCHomeScreen2 = () => {
  const navigate = useNavigate();

  // Create an AbortController instance
  const controller = new AbortController();
  // Obtain a reference to the AbortSignal
  const signal = controller.signal;

  const [controllerState, setControllerState] = useState(null)

  const [cersaiLoader, setCersaiLoader] = useState(false)

  const activeTabs = useSelector((state) => state.Tabs.activeTab);
  const activeSwitch = useSelector((state) => state.switchButton.activeSwitch);
  const { digitalForm60Id } = useSelector((state) => state.digitalFormSixty.formSixtyData);
  const userDetails = useSelector((state) => state.userDetails.userData);
  const disableTab = useSelector((state) => state.Tabs.disableTab);
  console.log("disable proprs", disableTab)
  const [isModalOpen, setIsModalOpen] = useState(true);
  // useEffect(() => {
  //   if (activeTabs === "pan") setIsModalOpen(true);
  // }, [activeTabs]);
  console.log("rerotur", userDetails.phoneNumber && (userDetails.totalKyc >= userDetails.limit))
  useEffect(() => {
    if (userDetails.phoneNumber && (userDetails.totalKyc >= userDetails.limit)) {
      console.log("inside")
      navigate("/home");
    }
  }, [])

  useEffect(() => {
    // disable browser button
    return () => {
      setTimeout(() => {
        window.history.forward();
      }, 0);
    };
  }, []);

  const [msg, setMsg] = useState([]);
  useEffect(() => {
    getAnnouncementMsg().then((data) => {
      setMsg(data);
    });
  }, []);

  return (
    <>
      {cersaiLoader ? (
        <Loader1 setCersaiLoader={setCersaiLoader}
          controllerState={controllerState}
        />
      ) : (
        <div className={styles["kycHome_container"]}>
          {activeTabs === "pan" && (
            <NewCommonTemplate
              isTemplateOpen={isModalOpen}
              closeTemplate={() => setIsModalOpen(false)}
            >
              {/* No scroll, content fits naturally */}
              <div
                className="
      flex flex-col items-center justify-start gap-y-1
      h-auto overflow-auto
    "
              >
                {/* Header */}
                <div className="flex justify-center items-center gap-[5px] mt-8 sm:mt-4">
                  <img
                    src="/assets/bell.svg"
                    alt="Alert"
                    className="w-[20px] h-[20px]"
                  />
                  <h2 className="font-bold text-[1.1rem] text-[#5A5A5A] text-center">
                    Announcement
                  </h2>
                </div>

                {/* Card 1 */}
                <div className="relative p-[10px] m-[5px_20px] border border-gray-300 rounded-lg bg-gradient-to-b from-[#ffffff] to-[#f5f5f5] text-center sm:text-left">
                  <img
                    src="/assets/Group 585.svg"
                    alt=""
                    className="absolute top-[0.01rem] left-[0.01rem] origin-left rounded-tr-sm rounded-br-sm"
                  />

                  <span className="absolute right-[-0.01rem] border border-gray-100 rounded-tl-[0.6rem] rounded-bl-[0.6rem] px-3 py-[4px]">
                    <img src="/assets/trending.svg" alt="" />
                  </span>

                  <h2 className="text-gray-700 font-semibold text-[1.1rem] text-center mt-8 sm:mt-0">
                    <span className="text-red-500">PAN</span> Mandate
                  </h2>

                  <p className="text-[#5A5A5A] text-[0.8rem] p-1 text-center sm:text-left">
                    Effective 1st April 2026, PAN/Form 97/Form 60 submission is mandatory to
                    complete KYC across all Pehchaan journeys, as per the new Income Tax
                    guidelines.
                  </p>
                </div>

                {/* Card 2 */}
                <div className="relative p-[10px] m-[5px_20px] border border-gray-300 rounded-lg bg-gradient-to-b from-[#ffffff] to-[#f5f5f5] text-center sm:text-left">
                  <img
                    src="/assets/Group 585.svg"
                    alt=""
                    className="absolute top-[0.01rem] left-[0.01rem] origin-left rounded-tr-sm rounded-br-sm"
                  />

                  <h2 className="text-gray-700 font-semibold text-[1.1rem] text-center mt-8 sm:mt-0">
                    Enhancing your <span className="text-red-500">KYC</span> Journey
                  </h2>

                  <p className="text-[#5A5A5A] text-[0.8rem] p-1 text-center sm:text-left">
                    We’re upgrading the Pehchaan platform to deliver a unified and guided
                    identity verification experience with improved usability and stronger
                    validation.
                  </p>

                  <p className="text-[#5A5A5A] font-semibold text-sm text-center">
                    The new experience will be available shortly.
                  </p>
                </div>

                {/* Card 3 – hidden on mobile */}
                <div className="hidden sm:block">
                  <div className="p-[10px] m-[5px_20px] border border-gray-300 rounded-lg bg-gradient-to-b from-[#ffffff] to-[#f5f5f5] text-center sm:text-left">
                    <h2 className="text-gray-700 font-semibold text-[1.1rem] text-center mt-8 sm:mt-0">
                      CERSAI <span className="text-red-500">CKYC</span> Update
                    </h2>

                    <p className="text-[#5A5A5A] text-[0.8rem] p-[2px_5px]">
                      As per the CERSAI guidelines, to complete your KYC, an OTP will now be
                      sent to your mobile number registered with CERSAI.
                    </p>

                    <p className="text-[#5A5A5A] text-[0.8rem] p-[2px_5px]">
                      Note: If this doesn’t work for you, no worries, you can still complete
                      your KYC using Aadhaar or OVD journey.
                    </p>
                  </div>
                </div>

                {/* Button */}
                <div className="m-auto w-[70%] sm:w-[35%] mb-[1rem]">
                  <CommonButton
                    center
                    label="Understood"
                    filled
                    onClickHandler={() => setIsModalOpen(false)}
                  />
                </div>
              </div>
            </NewCommonTemplate>
          )}
          <BannerImage>
            <LogoContainer />
          </BannerImage>
          <MsHome>
            <div className="bg-secondaryH md:h-[100%] md:overflow-hidden">
              <BottomCard>
                <>
                  <div className="md:flex-[0_0_auto]">
                    <label className="md:text-lg md:hidden sm:block">
                      <b>KYC Document</b>
                    </label>
                    <p className="text-sm md:hidden sm:block">
                      Let's fetch your kyc details using
                    </p>
                    <div className={"mb-3 md:hidden sm:block"}></div>
                    {!digitalForm60Id ? (
                      <div>
                        <Tab isDisabledTab={disableTab} />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="md:flex-[1_0_0] md:overflow-hidden">
                    {activeTabs === "pan" && (
                      <div className="h-full w-full md:flex md:flex-col ">
                        <PanCardFrame1 setCersaiLoader={setCersaiLoader}
                          setControllerState={setControllerState}
                          controller={controller}
                          signal={signal}

                        />
                      </div>
                    )}

                    {activeTabs === "aadhaar" && (
                      <div className="w-full h-full  md:flex md:flex-col ">
                        <AadhaarCardFrame />
                      </div>
                    )}
                    {activeTabs === "otherDocs" && (
                      <div className="w-full h-full   md:flex md:flex-col ">
                        <OtherDocsFrame />
                      </div>
                    )}
                  </div>
                </>
              </BottomCard>
            </div>
          </MsHome>
        </div>
      )}
    </>
  );
};

export default KYCHomeScreen2;





